import Message from 'ant-design-vue/lib/message';
import CommunityService from '@/io/community.js';
import BuildingService from '@/io/building.js';
import ResidentService from '@/io/resident.js';

export const $normalMargin = 24;

export const $formLabelCol = {
  span: 4
};

export const $formWrapperCol = {
  span: 20
};

export const $formEmptyLabelWrapperCol = {
  span: 20,
  offset: 4
};
//本地信息
export const $getCookie = name => {
  let arr = [];
  let reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  if (arr = document.cookie.match(reg)) {
    return (arr[2]);
  } else {
    return null;
  }
};

export const $setCookie = (name, value, expires = 1) => {
  let date = new Date();
  date.setDate(date.getDate() + expires);
  let dateStr = expires ? `;expires=${date.toGMTString()}` : '';
  document.cookie = `${name}=${value}${dateStr}`;
}

export const $delCookie = name => {
  let date = new Date();
  date.setTime(date.getTime() - 1);
  let target = $getCookie(name);
  if (target) {
    document.cookie = `${name}=${target};expires=${date.toGMTString()}`;
  }
}

// 防抖
export const $debounce = (fn = () => { }, delay = 500, immediate = false) => {
  let timer;
  if (immediate) {
    return (...args) => {
      if (timer) {
        clearTimeout(timer);
      } else {
        fn(...args);
      }
      timer = setTimeout(() => {
        timer = null;
      }, delay);
    };
  } else {
    return (...args) => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        fn(...args);
        timer = null;
      }, delay);
    };
  }
}

// 节流
export const $throttle = (fn = () => { }, delay = 800, immediate = false) => {
  let timer;
  if (immediate) {
    return (...args) => {
      if (timer) {
        return;
      } else {
        fn(...args);
      }
      timer = setTimeout(() => {
        timer = null;
      }, delay);
    };
  } else {
    return (...args) => {
      if (timer) {
        return;
      }
      timer = setTimeout(() => {
        fn(...args);
        timer = null;
      }, delay);
    };
  }
}

// 解除内存地址
export const $createNewVariable = variable => {
  return JSON.parse(JSON.stringify(variable));
}

// 对象转数组
export const $objToArray = target => Array.isArray(target) ? target : [target];

// 深度优先搜索
export const $depthSearchTree = (
  func = () => { },
  node = [],
  childrenKey = 'children'
) => {
  let newNode = $objToArray(node);
  newNode.forEach((value, index) => {
    value.position = index;
    func(value);
    let children = value[childrenKey];
    if (children) {
      $depthSearchTree(func, children, childrenKey);
    }
  });
}

// 广度优先搜索
export const $breadthSearchTree = (
  func = () => { },
  node = [],
  childrenKey = 'children'
) => {
  let newNode = $objToArray(node);
  while (newNode.length > 0) {
    let n = $objToArray(newNode.shift());
    n.forEach(value => {
      func(value);
      let children = value[childrenKey];
      if (children) {
        newNode.push(children);
      }
    });
  }
};

// 点字符串转对象取值
export const $strToObj = (name, data) => {
  return name.split('.').reduce((m, n) => m[n], data);
};

// 表单提交前
export const $beforeFormSubmit = (form, successCallback = () => { }, errorCallback = () => { }) => {
  form.validate(valid => {
    // console.log(12312312, form);
    if (valid) {


      $debounce(() => {
        Message.loading({ content: '拼命处理中，请稍候~', key: 'tips', duration: 2 });
        successCallback();
      }, null, true)();
    } else {
      Message.error('存在未正确填写的条目哦~');
      errorCallback();
    }
  });
}

// 表单提交后
export const $afterFormSubmit = (tips = '操作成功', callback = () => { }) => {
  Message.success({ content: tips, key: 'tips', duration: 1 });
  callback();
};





// 加载房源数据 社区-（接口）-楼栋-（接口）-单元-楼层-房号-（接口）-住户
export const $houseTreeData = (data, levelRange, communityId) => {
  let formatRootData = rootData => {
    if (data.length) {
      rootData = rootData.filter(val => data.map(m => m.id).indexOf(val.id) > -1);
    }
    rootData.forEach(val => {
      val._id = `c-${val.id}`;
      val.level = levelRange[0];
      val.levelRange = levelRange;
      val.children = [];
      val.name = val.name || val.alias;
    });
    return rootData;
  };
  let formatData = nodeData => {
    $depthSearchTree(node => {
      node._id = node.id;
      node.level = node.level || data.dataRef.level + 1;
      node.levelRange = data.dataRef.levelRange;
      node.communityId = $getCookie('communityId') * 1 || data.dataRef.communityId * 1 || data.dataRef.id * 1;
      // 门禁设备管理楼栋id
      node.buildId = data.dataRef.id * 1

      node.name = node.name || node.alias;
      node.children = node.children || [];
      node.isLeaf = node.level === data.dataRef.levelRange[1];
    }, nodeData);
    // data.dataRef.isLeaf = !nodeData.length;
    data.dataRef.children = nodeData;
  };
  if (data.dataRef) {
    if (data.dataRef.level === 0) {
      return BuildingService.listPage(data.dataRef.id).then(res => {
        formatData(res);
      }).catch(err => { });
    } else if (data.dataRef.level === 1 || data.dataRef.level === 2) {
      return BuildingService.houseTree(data.dataRef.id, data.dataRef.communityId).then(res => {
        formatData(res);
      }).catch(err => { });
    } else if (data.dataRef.level === 4) {
      return ResidentService.listPage(data.dataRef.communityId, data.dataRef.id).then(res => {
        formatData(res);
      }).catch(err => { });
    } else {
      return new Promise((resolve, reject) => resolve());
    }
  } else {
    if (levelRange[0] === 0) {
      return CommunityService.listPage().then(res => {
        return formatRootData(res);
      }).catch(err => { });
    } else if (levelRange[0] === 1) {
      return BuildingService.listPage(communityId || $getCookie('communityId')).then(res => {
        return formatRootData(res);
      }).catch(err => { });
    }
  }
}

export const $beforeUpload = file => {
  const isType = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
  if (!isType) {
    Message.error('请上传格式为jpeg、jpg或png的图片');
  }
  const isSize = file.size / 1024 / 1024 < 5;
  if (!isSize) {
    Message.error('图片大小小于5MB');
  }
  return isType && isSize;
}
export function $dateFormat(fmt, date) {
  console.log(date, '&&&')
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(),        // 年
    "M+": (date.getMonth() + 1).toString(),     // 月
    "D+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "m+": date.getMinutes().toString(),         // 分
    "s+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (const k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? opt[k] : opt[k].padStart(ret[1].length, "0"))
    }
  }
  return fmt;
}

export const generateUUID = () => {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

export const setFormData = (data, formData) => {
  for (const key in formData) {
    if (data[key] != null && data[key] != undefined) {
      formData[key] = data[key]
    }
  }
  return formData
}